import React, { useMemo } from "react";
import { Ptag } from "../fonts";
import { Radio, Image } from "./styles";
import RadioEmptyIcon from "assets/svgs/radio_empty.svg";
import RadioFilledIcon from "assets/svgs/radio_filled.svg";

const RadioCard = ({ text, isSelected, onSelect }) => {
  const selectionIcon = useMemo(() => {
    // displaying different icons based on selection
    if (isSelected) return RadioFilledIcon;
    return RadioEmptyIcon;
  }, [isSelected]);
  return (
    <Radio onClick={onSelect}>
      <Ptag fontSize="14px" fontWeight="600" marginLeft="14px">{text}</Ptag>
      <Image src={selectionIcon} />
    </Radio>
  );
};

export default RadioCard;
